var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9993 19.9414C26.371 19.9414 26.6811 20.2102 26.7435 20.5968L26.75 20.7L26.7495 24.2321C26.7495 25.5585 25.7164 26.655 24.3813 26.7448L24.2153 26.75L11.7779 26.7499C10.4462 26.7499 9.34529 25.7208 9.25525 24.391L9.25 24.2258V20.6863C9.25 20.2749 9.58596 19.9414 10.0003 19.9414C10.3719 19.9414 10.682 20.2102 10.7444 20.5968L10.7509 20.7L10.7504 24.2321C10.7504 24.7555 11.146 25.2013 11.6525 25.2534L11.767 25.2599L24.2217 25.2602C24.7449 25.2602 25.1902 24.8642 25.2423 24.3577L25.2489 24.2429L25.2492 20.6863C25.2492 20.2749 25.585 19.9414 25.9993 19.9414ZM18.0121 9.25C18.3715 9.25038 18.6815 9.51921 18.744 9.90576L18.7505 10.0089L18.7512 18.8297L21.9124 15.6749C22.1433 15.4447 22.4923 15.3934 22.7961 15.5476L22.9083 15.6149L22.9846 15.683C23.2334 15.9298 23.2646 16.3306 23.0409 16.6505L22.9652 16.7372L18.5142 21.1745L18.4327 21.2409L18.3271 21.3035L18.2368 21.3399L18.155 21.3617L18.0754 21.374L18.0133 21.3765L17.8901 21.3697L17.7855 21.3471L17.7029 21.3166L17.6007 21.2643L17.5424 21.2224L17.4569 21.1479L13.024 16.726C12.7317 16.4345 12.7327 15.9629 13.0264 15.6726C13.2865 15.4155 13.6903 15.3863 14.0115 15.6099L14.0985 15.6853L17.2506 18.8296L17.2496 9.9952C17.2496 9.61868 17.5327 9.30251 17.9055 9.25619L18.0121 9.25Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f12781fa25caf14c477a6769e1af7792.svg";
export { ForwardRef as ReactComponent };